module.exports = __webpack_public_path__ + "static/media/card_brand_ticket.89794509.svg";